import React from "react";
import { Divider, Form } from "semantic-ui-react";

const Dimensions = ({ context, variations, dimensions, product, errors, translate }) => (
    <div>
        {product.variations.length > 0 && <div>
            <Divider horizontal>Dimensions</Divider>
            {
                product.variations.map((variation, key) => {
                        const dimName = dimensions[variation.dimension_id].name;
                        return (
                            <Form.Dropdown
                                value={variation.id + "&" + variation.code}
                                key={key}
                                fluid
                                search
                                error={!!(typeof errors !== "undefined" && (errors.variations))}
                                disabled={!(dimName === "Jahrgang" || (dimName === "Volumen" && !!(typeof errors !== "undefined" && errors.volume)))}
                                label={translate("tools.general.dimensions." + dimName)}
                                selection
                                options={dimensions[variation.dimension_id].variations.sort((a, b) => a.order > b.order ? 1 : -1)
                                    .map((dimVariation) => ({
                                        key: dimVariation.id,
                                        text: dimVariation.name,
                                        value: dimVariation.id + "&" + dimVariation.code
                                    }))}
                                onChange={(e, { value }) => {

                                    let info = value.split("&");
                                    variations[key] = {
                                        dimension_id: variation.dimension_id,
                                        id: info[0],
                                        code: info[1]
                                    };
                                    context.setState(({ product }) => ({
                                        product: {
                                            ...product,
                                            variations
                                        }
                                    }), () => {
                                        context.dValidate();
                                    });
                                }}

                            />
                        );
                    }
                )
            }
        </div>}

    </div>
);

export default Dimensions;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/Steps/BasicInfos/components/Dimensions/index.js